import _ from 'lodash';
import { compose, withHandlers, lifecycle } from 'recompose';
import Http from '../../http';
import withNotifications from '../../common/withNotifications';
import config from '../../../config';

const width = 800;
const height = 650;
const DEFAULT_OPTIONS = {
  size: { width, height },
  redirectUriParam: 'redirect_uri',
};

let onPopupMessage;

const withOAuthHandler = compose(
  withNotifications,
  withHandlers({
    authorize: props => (
      authUrl,
      service,
      callback,
      options = DEFAULT_OPTIONS
    ) => {
      let callbackUrl;
      const { size, redirectUriParam } = _.merge({}, DEFAULT_OPTIONS, options);
      const parameters = `location=1,width=${size.width},height=${size.height}` +
                         `,left=${(screen.width - size.width) / 2},top=${(screen.height - size.height) / 2}`;
      const redirectUri = `${window.location.origin}/authorize/${service}`;
      const redirectUriRegex = new RegExp(`${redirectUriParam}=[^&]+`);
      const matchUri = authUrl.match(redirectUriRegex);
      let url;
      if (matchUri) {
        callbackUrl = decodeURIComponent(matchUri[0].replace(`${redirectUriParam}=`, '').replace(/\+/g, ' '));
        url = `${authUrl.replace(redirectUriRegex, `${redirectUriParam}=${redirectUri}`)}`;
      } else {
        url = `${authUrl}&${redirectUriParam}=${redirectUri}`;
      }
      window.open(url, 'oAuthPopup', parameters);

      onPopupMessage = (event) => {
        // Check the origin of the data!
        if (event.origin === window.location.origin && event.data.type === 'authorize') {
          if (event.data.error) {
            let message;
            if (event.data.access_denied !== undefined) {
              message = 'You need to allow access to GetSquire application.';
            } else if (event.data.invalid_scope !== undefined) {
              message = 'Error occurred while trying to connect your account.';
            }
            props.addNotification({
              message,
            });

            return;
          }
          const params = {
            ...event.data.params,
            redirect_uri: redirectUri,
          };
          if (callbackUrl !== '') {
            callbackUrl = callbackUrl.replace(`${config.url}/v1`, '');
            Http.get(callbackUrl, params).then(() => callback(event.data.params));
          } else {
            callback(event.data.params);
          }
        }
      };
      window.addEventListener('message', onPopupMessage, false);
    },
  }),
  lifecycle({
    componentWillUnmount() {
      if (typeof onPopupMessage === 'function') {
        window.removeEventListener('message', onPopupMessage, false);
      }
    },
  })
);

export default withOAuthHandler;
